import ApiService from '@/utils/ApiService'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    taskTypeOptions: [],
    caseTypeOptions: []
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    taskTypeOptions (state) {
      let taskTypeOptions = state.taskTypeOptions.map(option => {
        return { value: option['@id'], text: option.title + (option.idCasesType ? ' (' + option.idCasesType.title + ')' : '') }
      })
      taskTypeOptions.unshift({
        text: Vue.prototype.$lang.t('global.notSet'),
        value: null
      })
      return taskTypeOptions
    },
    caseTypeOptions (state) {
      let caseTypeOptions = state.caseTypeOptions.map(option => {
        return { value: option['@id'], text: option.title }
      })
      caseTypeOptions.unshift({
        text: Vue.prototype.$lang.t('global.notSet'),
        value: null
      })
      return caseTypeOptions
    },
    firingThroughOptions () {
      return [
        { value: 1, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.firingThrough.createCase') },
        { value: 2, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.firingThrough.closeCase') },
        { value: 3, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.firingThrough.createTask') },
        { value: 4, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.firingThrough.assignTask') },
        { value: 5, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.firingThrough.returnTask') },
        { value: 6, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.firingThrough.startTask') },
        { value: 7, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.firingThrough.finishTask') },
        { value: 8, text: Vue.prototype.$lang.t('views.excmnotificationmessage.form.firingThrough.uploadDocumentCase') },
        { value: 9, text: Vue.prototype.$lang.t('views.excmnotificationmessage.form.firingThrough.uploadDocumentTask') },
        { value: 10, text: Vue.prototype.$lang.t('views.excmnotificationmessage.form.firingThrough.addAdditionalInfoInTask') },
        { value: 11, text: Vue.prototype.$lang.t('views.excmnotificationmessage.form.firingThrough.deadlineDateExceeded') }
      ]
    },
    recipientTypeOptions () {
      return [
        { value: 1, text: Vue.prototype.$lang.t('roles.roleServiceman') },
        { value: 2, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.servicemanInTeam') },
        { value: 3, text: Vue.prototype.$lang.t('roles.roleDispatcher') },
        { value: 4, text: Vue.prototype.$lang.t('roles.roleClient') },
        { value: 5, text: Vue.prototype.$lang.t('roles.roleControlling') },
        { value: 6, text: Vue.prototype.$lang.t('roles.roleWholesaler') },
        { value: 7, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.userDataRegion') },
        { value: 8, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.ownerUserData') },
        { value: 9, text: Vue.prototype.$lang.t('views.exsbmessagesperiodic.form.userDataSalesRegion') },
        { value: 10, text: Vue.prototype.$lang.t('views.excmnotificationmessage.form.wholesalerEmployee') },
        { value: 11, text: Vue.prototype.$lang.t('views.ticket.list.table.userEmailFromApplication') }
      ]
    }
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    },
    setTaskTypeOptions (state, payload) {
      state.taskTypeOptions = payload
    },
    setCaseTypeOptions (state, payload) {
      state.caseTypeOptions = payload
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_s_b_messages_periodics') {
      commit('toggleLoading')
      const response = await new ApiService(url).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('toggleLoading')
    },
    async fetchTaskTypeOptions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_task_types', baseParams).getResults()
      commit('setTaskTypeOptions', await response.items)
    },
    async fetchCaseTypeOptions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_case_types', baseParams).getResults()
      commit('setCaseTypeOptions', await response.items)
    }
  }
}
